var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 84,
    viewBox: "0 0 139 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_681_985)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.1694 56.5378V34.7502H103.322V61.776H84.324C78.4834 61.776 73.703 56.9269 73.703 51.0909V34.7407H79.8749V51.0909C79.8749 54.0516 82.2698 56.5283 85.2422 56.5283H97.1694V56.5378Z",
    fill: "#FCFCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.036 50.8725H116.215C111.785 50.8725 108.131 47.2475 108.131 42.8065C108.131 38.3655 111.766 34.7595 116.215 34.7595H135.942V40.0071H117.095C115.553 40.0071 114.284 41.2787 114.284 42.816C114.284 44.3533 115.553 45.6438 117.095 45.6438H130.916C135.346 45.6438 139 49.2498 139 53.6908C139 58.1319 135.365 61.7948 130.916 61.7948H109.172V56.5471H130.036C131.579 56.5471 132.857 55.2186 132.857 53.6908C132.857 52.163 131.569 50.882 130.036 50.882V50.8725Z",
    fill: "#FCFCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.5314 18.8554V27.0258H75.3784V13.6078H94.3106C96.5919 13.6078 98.4851 11.7099 98.4851 9.42296C98.4851 7.13601 96.5919 5.23814 94.3106 5.23814H75.3784V0H95.2288C100.397 0 104.638 4.25124 104.638 9.43244C104.638 14.6136 100.397 18.8649 95.2288 18.8649H81.5314V18.8554Z",
    fill: "#FCFCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.8268 41.3736L40.477 61.7853H33.6614L48.7125 34.75H54.9506L69.9922 61.7853H63.1766L51.8268 41.3736Z",
    fill: "#FCFCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.8757 0H40.335L51.8079 13.3136L63.3187 0H70.7779L54.8844 18.4758V27.0258H48.7693V18.5043L33.3774 0.578852L32.8757 0Z",
    fill: "#FCFCFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.088 5.24763V0H110.043V27.0258H137.088V21.7781H116.206V15.0502H135.119V9.80253H116.225V5.23814H137.088V5.24763Z",
    fill: "#FCFCFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0987 9.41347V0H22.9363V9.40398H6.17188L12.3343 14.5188H22.9363V27.0258H29.0987V14.5188L22.9363 9.41347H29.0987Z",
    fill: "#FCFCFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 14.4998L6.17189 9.40398V0H0V14.4998Z",
    fill: "#FCFCFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.17189 14.4998H0V27.0257H6.17189V14.4998Z",
    fill: "#FCFCFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0987 44.173V34.75H22.9363V44.1635H6.17188L12.3343 49.2688H22.9363V61.7758H29.0987V49.2688L22.9363 44.173H29.0987Z",
    fill: "#FCFCFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 49.2498L6.17189 44.1635V34.75H0V49.2498Z",
    fill: "#FCFCFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.17189 49.25H0V61.776H6.17189V49.25Z",
    fill: "#FCFCFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.18667 81.2765V83.9999H0.605835V77.1296H7.82846V78.3727H2.18667V80.0429H7.42142V81.286H2.18667V81.2765Z",
    fill: "#FCFCFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9523 83.9999V77.1296H12.5426V83.9999H10.9523Z",
    fill: "#FCFCFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3581 83.9999V78.3727H15.8273V77.1296H24.413V78.3727H20.9579V83.9999H19.3581Z",
    fill: "#FCFCFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1699 83.9999L29.0324 78.9896V83.9999H27.6504V77.1296H29.023L35.5546 81.8364V77.1296H36.9461V83.9999H36.1699Z",
    fill: "#FCFCFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5811 83.9999V77.1296H47.8037V78.3727H42.1714V79.7487H47.5102V81.0013H42.1714V82.7568H47.8037V84.0094H40.5811V83.9999Z",
    fill: "#FCFCFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3725 83.9999V82.7474H57.4687C57.9136 82.7474 58.0934 82.6714 58.0934 82.3393V81.3524C58.0934 81.0393 57.9041 80.9349 57.4687 80.9349H53.3698C51.7606 80.9349 51.1548 80.2611 51.1548 79.2647V78.7998C51.1548 77.8034 51.7701 77.1296 53.3698 77.1296H59.2956V78.3727H53.3698C52.9533 78.3727 52.7356 78.4771 52.7356 78.7903V79.2742C52.7356 79.5684 52.9249 79.6918 53.3698 79.6918H57.4687C59.0779 79.6918 59.6837 80.3655 59.6837 81.3619V82.3203C59.6837 83.3167 59.0684 83.9999 57.4687 83.9999H51.3725Z",
    fill: "#FCFCFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.205 83.9999V82.7474H69.3012C69.7461 82.7474 69.9259 82.6714 69.9259 82.3393V81.3524C69.9259 81.0393 69.7366 80.9349 69.3012 80.9349H65.2024C63.5931 80.9349 62.9873 80.2611 62.9873 79.2647V78.7998C62.9873 77.8034 63.6026 77.1296 65.2024 77.1296H71.1281V78.3727H65.2024C64.7859 78.3727 64.5681 78.4771 64.5681 78.7903V79.2742C64.5681 79.5684 64.7575 79.6918 65.2024 79.6918H69.3012C70.9104 79.6918 71.5163 80.3655 71.5163 81.3619V82.3203C71.5163 83.3167 70.901 83.9999 69.3012 83.9999H63.205Z",
    fill: "#FCFCFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0664 83.9999V80.9918H83.8506V83.9999H82.2603V77.1296H83.8506V79.7487H89.0664V77.1296H90.6661V83.9999H89.0664Z",
    fill: "#FCFCFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4499 83.9999C94.8501 83.9999 94.2538 83.3262 94.2538 82.3393V78.7903C94.2538 77.8034 94.8596 77.1296 96.4499 77.1296H101.098C102.698 77.1296 103.294 77.8034 103.294 78.7903V82.3393C103.294 83.3262 102.688 83.9999 101.098 83.9999H96.4499ZM101.704 78.7713C101.704 78.4961 101.486 78.3727 101.088 78.3727H96.4404C96.0429 78.3727 95.8252 78.4961 95.8252 78.7713V82.3488C95.8252 82.6335 96.0429 82.7474 96.4404 82.7474H101.088C101.486 82.7474 101.704 82.6335 101.704 82.3488V78.7713Z",
    fill: "#FCFCFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.047 77.1296H115.638V82.3393C115.638 83.3262 115.032 83.9999 113.442 83.9999H109.068C107.468 83.9999 106.872 83.3262 106.872 82.3393V77.1296H108.462V82.3488C108.462 82.6335 108.68 82.7474 109.078 82.7474H113.451C113.849 82.7474 114.066 82.6335 114.066 82.3488V77.1296H114.047Z",
    fill: "#FCFCFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.339 83.9999V82.7474H125.435C125.88 82.7474 126.06 82.6714 126.06 82.3393V81.3524C126.06 81.0393 125.871 80.9349 125.435 80.9349H121.336C119.727 80.9349 119.112 80.2611 119.112 79.2647V78.7998C119.112 77.8034 119.727 77.1296 121.336 77.1296H127.262V78.3727H121.336C120.92 78.3727 120.702 78.4771 120.702 78.7903V79.2742C120.702 79.5684 120.891 79.6918 121.336 79.6918H125.435C127.044 79.6918 127.65 80.3655 127.65 81.3619V82.3203C127.65 83.3167 127.035 83.9999 125.435 83.9999H119.339Z",
    fill: "#FCFCFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.086 83.9999V77.1296H138.309V78.3727H132.677V79.7487H138.016V81.0013H132.677V82.7568H138.309V84.0094H131.086V83.9999Z",
    fill: "#FCFCFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_681_985"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 139,
    height: 84,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8e43f44f69c2703df60f38a9df28647b.svg";
export { ForwardRef as ReactComponent };